import 'suggestions-jquery';
import {initFullnameSuggestions} from './src/dadata.name';
import {initMailSuggestions} from './src/dadata.mail';
import './src/dadata.address';
import './src/utils';
import {
  Menu
} from './src/sidebar';
import './src/cleave';
import {
  Dialog
} from './src/dialog';
import './src/message';
import './src/notice';
import {
  search
} from './src/search';
import LazyLoad from 'vanilla-lazyload';
import {
  showCookie
} from './src/cookie';
import './src/menu';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import {
  Accordeon
} from './src/accordeon';
import {isHelloVisit} from './src/hello';
import './src/banner';


export const mobileMenu = new Menu('#menu');
export const dialog = new Dialog();

search.init();
export const lazy = new LazyLoad({
  elements_selector: '.lazyload'
});
showCookie();
document.body.classList.add('page-loaded');

tippy('[data-tippy-content]');

new Accordeon('.footer__menu');

initFullnameSuggestions('.suggest-fullname');
initMailSuggestions('.suggest-email');
isHelloVisit();
